export default __webpack_public_path__ + "static/media/output.b157296c.mp3";